import { NgModule } from '@angular/core';
import { IfPlatformDirective } from './if-platform.directive';
import { ImgLoaderDirective } from './img-loader.directive';
import { ImageIxImageDirective } from './imgix-src.directive';
import { JsonLdSchemaDirective } from './json-ld-schema.directive';
import { OutsideClickDirective } from './outsideClick.directive';
import { RmSwiperDirective } from './rm-swiper.directive';
import { ScrollDirective } from './scroll.directive';
import { ShowAuthedDirective } from './show-authed.directive';
import { LazyComponentDirective } from './lazy-component.directive'
import { TabMarkerDirective } from './tab-marker.directive';

@NgModule({
  imports: [],
  declarations: [
    IfPlatformDirective,
    ImgLoaderDirective,
    ImageIxImageDirective,
    JsonLdSchemaDirective,
    OutsideClickDirective,
    RmSwiperDirective,
    ScrollDirective,
    ShowAuthedDirective,
    LazyComponentDirective,
    TabMarkerDirective
  ],
  exports: [
    IfPlatformDirective,
    ImgLoaderDirective,
    ImageIxImageDirective,
    JsonLdSchemaDirective,
    OutsideClickDirective,
    RmSwiperDirective,
    ScrollDirective,
    ShowAuthedDirective,
    LazyComponentDirective,
    TabMarkerDirective
  ]
})
export class SharedDirectivesModule { }
